/**
 * Post Elementor Widget.
 *
 * @version 1.0.0
 * @since 1.0.0
 */

( function ( $ ) {
	'use strict';
	// eslint-disable-next-line no-shadow
	const RbbPostsHandler = function ( $scope, $ ) {
		const $element = $( $scope ).find( '.slick-carousel' );

		if ( $element.length ) {
			$element.slick( { rtl: window.rbb_vars.rtl === 'true' } );

			const $select = $element.closest( '.rbb_posts' ).find( 'select' );
			// eslint-disable-next-line no-undef
			RbbSelectAjax.render(
				$select,
				function ( data ) {
					$element.slick( 'unslick' );
					$element.html( data );
					$element.slick();
				},
				function () {
					$( document.body ).triggerHandler(
						'rbb-select-ajax-before-send',
						$element
					);
				},
				function () {
					$( document.body ).triggerHandler(
						'rbb-select-ajax-complete',
						$element
					);
				}
			);
		}
	};

	// Make sure you run this code under Elementor.
	$( window ).on( 'elementor/frontend/init', function () {
		elementorFrontend.hooks.addAction(
			'frontend/element_ready/rbb_posts.default',
			RbbPostsHandler
		);
	} );
} )( jQuery );
